/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Scope inheritance options */
export enum ScopeInheritance {
  None,
  Hierarchical,
  Delegated,
  Inherited,
}

export type ScopeInheritanceArgs = ScopeInheritance;

export function getScopeInheritanceEncoder(): FixedSizeEncoder<ScopeInheritanceArgs> {
  return getEnumEncoder(ScopeInheritance);
}

export function getScopeInheritanceDecoder(): FixedSizeDecoder<ScopeInheritance> {
  return getEnumDecoder(ScopeInheritance);
}

export function getScopeInheritanceCodec(): FixedSizeCodec<
  ScopeInheritanceArgs,
  ScopeInheritance
> {
  return combineCodec(
    getScopeInheritanceEncoder(),
    getScopeInheritanceDecoder(),
  );
}
